import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import NavbarV2 from './navbar-v2';
import FooterV2 from './footer-v2';

export default function Permissions() {
  // Sayfa yüklendiğinde en üste scroll yap
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const permissions = [
    { 
      name: 'Kamera', 
      purpose: 'Profil fotoğrafı çekmek veya seçmek', 
      trigger: 'Kullanıcı aksiyonu (fotoğraf ekle)', 
      required: 'Hayır (opsiyonel)',
      icon: '📷'
    },
    { 
      name: 'Bildirimler', 
      purpose: 'Hatırlatma ve grup etkinliği bilgilendirmeleri', 
      trigger: 'Kullanıcı izni sonrası', 
      required: 'Hayır (opsiyonel)',
      icon: '🔔'
    },
    { 
      name: 'Depolama / Medya', 
      purpose: 'Galeriden profil fotoğrafı seçmek', 
      trigger: 'Kullanıcı aksiyonu', 
      required: 'Hayır (opsiyonel)',
      icon: '📁'
    },
    { 
      name: 'İnternet', 
      purpose: 'Sunucu ile veri senkronizasyonu', 
      trigger: 'Arka planda', 
      required: 'Evet (temel işlev)',
      icon: '🌐'
    },
  ];

  return (
    <div className="bg-white">
      <NavbarV2 />
      
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-purple-50 to-indigo-50 py-16 pt-24">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Android İzinleri</h1>
            <p className="text-lg text-gray-600 mb-6">
              Uygulamamızın talep ettiği izinler ve kullanım amaçları
            </p>
            <div className="flex items-center justify-center text-sm text-gray-500">
              <Link to="/" className="hover:text-red-500">Ana Sayfa</Link>
              <span className="mx-2">/</span>
              <span className="text-red-500">Android İzinleri</span>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-6xl mx-auto">
            <div className="bg-white border rounded-xl p-8 shadow-sm">
              {/* Introduction */}
              <div className="mb-8 p-6 bg-blue-50 border border-blue-200 rounded-lg">
                <div className="flex items-start">
                  <svg className="w-6 h-6 text-blue-600 mt-1 mr-3 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <div>
                    <h3 className="font-semibold text-blue-800 mb-2">Gizlilik Öncelikli Yaklaşım</h3>
                    <p className="text-blue-700 text-sm">
                      Uygulamamız yalnızca gerekli izinleri talep eder. İzin vermediğiniz takdirde ilgili özellik 
                      devre dışı kalır ancak temel işlevler (hesap, okuma takibi) çalışmaya devam eder.
                    </p>
                  </div>
                </div>
              </div>

              {/* Permissions Cards */}
              <div className="mb-12">
                <h2 className="text-2xl font-semibold text-gray-800 mb-6">İzin Detayları</h2>
                <div className="grid lg:grid-cols-2 gap-6">
                  {permissions.map((permission, index) => (
                    <div key={index} className="bg-gray-50 rounded-xl p-6 border border-gray-200">
                      <div className="flex items-start mb-4">
                        <div className="text-2xl mr-4 bg-white p-3 rounded-lg shadow-sm">
                          {permission.icon}
                        </div>
                        <div className="flex-1">
                          <h3 className="text-xl font-semibold text-gray-800 mb-2">{permission.name}</h3>
                          <div className={`inline-flex px-3 py-1 rounded-full text-xs font-medium ${
                            permission.required.includes('Evet') 
                              ? 'bg-red-100 text-red-800' 
                              : 'bg-green-100 text-green-800'
                          }`}>
                            {permission.required}
                          </div>
                        </div>
                      </div>
                      
                      <div className="space-y-3 text-sm">
                        <div>
                          <span className="font-medium text-gray-700">Kullanım Amacı:</span>
                          <p className="text-gray-600 mt-1">{permission.purpose}</p>
                        </div>
                        <div>
                          <span className="font-medium text-gray-700">Ne Zaman İstenir:</span>
                          <p className="text-gray-600 mt-1">{permission.trigger}</p>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Permissions Table - Desktop View */}
              <div className="hidden lg:block mb-8">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">İzinler Özet Tablosu</h3>
                <div className="overflow-hidden rounded-lg border border-gray-200">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">İzin</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amaç</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Tetiklenme</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Zorunluluk</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {permissions.map((permission, index) => (
                        <tr key={index} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap">
                            <div className="flex items-center">
                              <span className="text-lg mr-2">{permission.icon}</span>
                              <span className="text-sm font-medium text-gray-900">{permission.name}</span>
                            </div>
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-600">{permission.purpose}</td>
                          <td className="px-6 py-4 text-sm text-gray-600">{permission.trigger}</td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`inline-flex px-2 py-1 text-xs font-semibold rounded-full ${
                              permission.required.includes('Evet') 
                                ? 'bg-red-100 text-red-800' 
                                : 'bg-green-100 text-green-800'
                            }`}>
                              {permission.required}
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Additional Info */}
              <div className="space-y-6">
                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">İzin Yönetimi</h2>
                  <div className="text-gray-700 space-y-4">
                    <p>
                      Android cihazınızda uygulama izinlerini dilediğiniz zaman değiştirebilirsiniz:
                    </p>
                    <div className="bg-gray-50 p-6 rounded-lg">
                      <h3 className="font-semibold mb-3">İzin Ayarları Yolu:</h3>
                      <ol className="list-decimal ml-6 space-y-2 text-sm">
                        <li><strong>Ayarlar</strong> uygulamasını açın</li>
                        <li><strong>Uygulamalar</strong> veya <strong>Uygulama Yöneticisi</strong>'ne gidin</li>
                        <li><strong>Hatim Takip</strong> uygulamasını bulun</li>
                        <li><strong>İzinler</strong> seçeneğine tıklayın</li>
                        <li>İstediğiniz izni açıp kapatabilirsiniz</li>
                      </ol>
                    </div>
                  </div>
                </section>

                <section>
                  <h2 className="text-2xl font-semibold text-gray-800 mb-4">Veri Güvenliği</h2>
                  <div className="text-gray-700">
                    <div className="grid md:grid-cols-2 gap-6">
                      <div className="bg-green-50 p-6 rounded-lg border border-green-200">
                        <h3 className="font-semibold text-green-800 mb-2">✅ Yaptıklarımız</h3>
                        <ul className="text-green-700 text-sm space-y-1">
                          <li>• Minimum gerekli izinleri talep ederiz</li>
                          <li>• Verileri güvenli şekilde saklarız</li>
                          <li>• Üçüncü taraflarla paylaşmayız</li>
                          <li>• Şeffaf bilgilendirme yaparız</li>
                        </ul>
                      </div>
                      <div className="bg-red-50 p-6 rounded-lg border border-red-200">
                        <h3 className="font-semibold text-red-800 mb-2">❌ Yapmadıklarımız</h3>
                        <ul className="text-red-700 text-sm space-y-1">
                          <li>• Gereksiz izin talep etmeyiz</li>
                          <li>• Gizli veri toplamayız</li>
                          <li>• İzinsiz arka plan aktivitesi yapmayız</li>
                          <li>• Kişisel verileri satmayız</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>
              </div>

              {/* Related Pages */}
              <div className="mt-12 pt-8 border-t border-gray-200">
                <h3 className="text-lg font-semibold text-gray-800 mb-4">İlgili Sayfalar</h3>
                <div className="grid md:grid-cols-3 gap-4">
                  <Link 
                    to="/privacy-policy" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Gizlilik Politikası</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Veri koruma ve gizlilik uygulamaları
                    </p>
                  </Link>
                  <Link 
                    to="/terms-of-service" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Kullanım Koşulları</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Uygulama kullanım kuralları
                    </p>
                  </Link>
                  <Link 
                    to="/support" 
                    className="block p-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
                  >
                    <h4 className="font-medium text-gray-800">Destek</h4>
                    <p className="text-sm text-gray-600 mt-1">
                      Teknik destek ve yardım
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <FooterV2 />
    </div>
  );
}
